import React from "react";

const CalendarLegend = () => (
  <div className="calendar-legend" aria-label="Calendar legend">
    <span className="calendar-legend__item">
      <span className="calendar-legend__swatch calendar-legend__swatch--closed" aria-hidden="true" />
      Days closed
    </span>
    <span className="calendar-legend__item">
      <span className="calendar-legend__swatch calendar-legend__swatch--auto-draft" aria-hidden="true" />
      Fee auto-draft dates
    </span>
    <span className="calendar-legend__item">
      <span className="calendar-legend__swatch calendar-legend__swatch--today" aria-hidden="true" />
      Today
    </span>
  </div>
);

export default CalendarLegend;
